module.exports = __webpack_public_path__ + "static/img/dde.98815db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dde.png
// module id = gt00
// module chunks = 0